import { Component, createSignal, For, Match, onMount, Show, Switch } from "solid-js"
import { Artwork, ListItem } from "../types"
import { createStore } from "solid-js/store";
import { fetchGet } from "../api";
import { PageList } from "../components/page-list";
import { Img } from "../components/universal/image";

type Props = {
    artwork: Artwork;
}

type Resources = {
    yesNos: ListItem[];
    orderBy: ListItem[];
}
type Filter = {
    startsWith: string;
    medium: string;
    country: string;
    title: string;
    translatedTitle: string;
    startYear: string;
    endYear: string;
    page: number;
    pageRows: number;
    order: string;
    direction: string;
}
type _Artist = {
    Id: number;
    Slug: string;
    FirstName: string;
    LastName: string;
}
type _ArtworkLocation ={
    Id: number;
    Name: string;
    City: string;
    Country: string;
    CountryCode: string;
}
type _NewImage = {
    Id: number;
    URL: string;
    Height: number;
    Width: number;
}
type _Artwork = {
    Id: number;
    Title: string;
    AlternateTitle: string;
    TranslatedTitle: string;
    Slug: string;
    Medium: string;
    Measurements: string;
    DateRange: string;
    Artist: _Artist;
    ArtCollection: _ArtworkLocation;
    ImageCount: number;
    PrimaryImage: _NewImage;
    DateAdded: string;
    IsDeleted: boolean;
}

export const SimilarTitlesTab : Component<Props> = ({ artwork }) => {
    const [filter, setFilter] = createStore<Filter>({
        title: "",
        translatedTitle: artwork.translatedTitle,
        medium: "",
        startYear: "",
        endYear: "",
        page: 1,
        pageRows: 20,
        order: "ByArtist",
        direction: "Ascending"
    } as Filter);
    const [blockSize, setBlockSize] = createSignal<number>(20);
    const [count, setCount] = createSignal<number>(0);
    const [page, setPage] = createSignal<number>(1);
    const [maxPage, setMaxPage] = createSignal<number>(1);
    const [list, setList] = createStore<Resources>({
        yesNos: [
            { Text: "", Value: "" },
            { Text: "Yes", Value: "Yes" },
            { Text: "No", Value: "No" }
        ],
        orderBy: [
            { Text: "By default", Value: "ByDefault" },
            { Text: "By title", Value: "ByTitle" },
            { Text: "By date", Value: "ByDate" },
            { Text: "By medium", Value: "ByMedium" },
            { Text: "By artist", Value: "ByArtist" },
            { Text: "By date added", Value: "ByDateAdded" },
            { Text: "By random artworks", Value: "ByRandom" }
        ]
    });
    const [artworks, setArtworks] = createStore<_Artwork[]>([]);
    const search = async () => {
        const res = await fetchGet("/Artwork/SearchSimilarTitlesJson", filter);
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        setFilter("page", json.Data.Page);
        setCount(json.Data.Count);
        setPage(json.Data.Page);
        setMaxPage(json.Data.MaxPage);
        setArtworks(json.Data.Results);
    };
    const loadPage = async (p: number) => {
        setFilter("page", p);
        await search();
    }
    const handleSubmit = async (e: Event) => {
        e.preventDefault();
        await search();
    }
    const resetFields = () => {

    };
    const clearClicked = async (e: Event) => {
        e.preventDefault();
        resetFields();
        await search();
    }
    onMount(async () => {
        setFilter("title", artwork.title);
        await search();
    });
    const w = 250;
    return (
        <div style="background-color: #efefef; color: #333; text-align: left;">
            <form onSubmit={handleSubmit} style="padding: 20px;">
                <div class="row">
                    <div class="col-md-3">
                        <label>Title</label>
                        <input
                            type="text"
                            class="form-control"
                            value={filter.title}
                            onInput={(e) => setFilter("title", e.currentTarget.value)}
                        />
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-default" onClick={clearClicked}>Clear</button>
                        <button type="submit" class="btn btn-primary">Search</button>
                    </div>
                </div>
            </form>
            <section class="salon-results">
                <div>
                    <PageList page={page} maxPage={maxPage} blockSize={blockSize} onClick={loadPage} />
                </div>
                <div style="background-color: #000; position: relative; text-align: center;">
                    <div class="finalist-grid">
                        <For each={artworks}>{(artwork) => {
                            const mps = artwork.PrimaryImage.Height && artwork.PrimaryImage.Width ? (artwork.PrimaryImage.Height * artwork.PrimaryImage.Width) / 1000000 : 1;
                            return (
                        <div class="grid-item" style={"display: inline-block; text-align: left; vertical-align: top; width: "+ w +"px;"}>
                            <div>
                                <div style={{ "position": "relative", "background-color": "#333" }}>
                                    <div>
                                        <a href={ `/artworks/${artwork.Slug}/${artwork.Artist.Slug}/${artwork.Id}` }>
                                            <Show when={artwork.PrimaryImage}>
                                                <Img
                                                    class="artwork-image"
                                                    alt={artwork.Title}
                                                    src={artwork.PrimaryImage.URL }
                                                    mode="crop" width={w} format="JPEG"
                                                    style={"width: "+ w +"px;"}
                                                />
                                            </Show>
                                        </a>
                                        <Show when={artwork.ImageCount > 1}>
                                            <div class="inset">
                                                <a href={`/artworks/${artwork.Slug}/${artwork.Artist.Slug}/${artwork.Id}`} target="_blank">+ {artwork.ImageCount - 1} more</a>
                                            </div>
                                        </Show>
                                    </div>
                                </div>
                                {/* <Show when={artwork.isForSale}>
                                    <div style="background-color: darkgoldenrod; padding: 10px 15px; font-family: 'Oswald'; font-size: 1.5em;">
                                        <a href={ "/Artwork/Enquire?artworkId=" + artwork.id + "&campaign=ARCArtist" } style="color: #000;">Enquire about purchase <span class="fa fa-angle-double-right"></span></a>
                                    </div>
                                </Show>
                                <Show when={artwork.isSold}>
                                    <div style="background-color: #d2f7da; padding: 10px 15px; font-family: 'Oswald'; text-align: center; font-size: 1.5em;">
                                        SOLD
                                    </div>
                                </Show> */}
                                <div class="didactic" style={"width: "+ w + "px; margin: 0;"}>
                                    <Show when={artwork.PrimaryImage && artwork.PrimaryImage.Height >= 2000 || artwork.PrimaryImage.Width >= 2000}>
                                        <span style="float: right;" class="hd">HD</span>
                                    </Show>
                                    <h1>
                                        <a href={ `/artworks/${artwork.Slug}/${artwork.Artist.Slug}/${artwork.Id}` } target="_blank">
                                            <span innerHTML={artwork.Title}></span>
                                        </a>
                                    </h1>
                                    <Show when={!!artwork.AlternateTitle}>
                                        <h4 innerHTML={artwork.AlternateTitle}></h4>
                                    </Show>
                                    <Show when={!!artwork.TranslatedTitle}>
                                        <h4 innerHTML={artwork.TranslatedTitle}></h4>
                                    </Show>
                                    <Show when={artwork.Artist}>
                                        <h4>
                                            <a href={`/artists/${artwork.Artist.Slug}/${artwork.Artist.Id}`}>{artwork.Artist.FirstName} {artwork.Artist.LastName}</a>
                                        </h4>
                                    </Show>
                                    <p class="date"><strong>{artwork.DateRange}</strong></p>
                                    <p>{artwork.Medium}</p>
                                    <p innerHTML={artwork.Measurements}></p>
                                    <Show when={!!artwork.ArtCollection}>
                                        <p class="art-collection">
                                            <a href={ "/ArtCollection/Index/" + artwork.ArtCollection.Id }>{artwork.ArtCollection.Name}</a> {artwork.ArtCollection.City} | {artwork.ArtCollection.Country}
                                        </p>
                                    </Show>
                                    <Switch>
                                        <Match when={mps < 1}>
                                            <div>
                                                less than 1 MP
                                            </div>
                                        </Match>
                                        <Match when={mps == 1}>
                                            <div>
                                                1 MP
                                            </div>
                                        </Match>
                                        <Match when={mps > 1}>
                                            <div>
                                                {Math.round(mps)} MPs
                                            </div>
                                        </Match>
                                    </Switch>
                                </div>
                            </div>
                        </div>);
                        }
                    }</For>     
                </div>
            </div>
        </section>
    </div>
    )
}